import { client } from 'util/sdk';

export default ({ fspId, id }) =>
  client
    .fsps(fspId)
    .scheduledTransactionsAuditLogs.query((_) => [
      _.scheduledTransactionId(id),
    ]);
